import { render, staticRenderFns } from "./PlantDetail.vue?vue&type=template&id=f13ffe6c&"
import script from "./PlantDetail.vue?vue&type=script&lang=js&"
export * from "./PlantDetail.vue?vue&type=script&lang=js&"
import style0 from "./PlantDetail.vue?vue&type=style&index=0&id=f13ffe6c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports